import "./HomePage.css";

function HomePage() {
	return (
		<div className="center">
				<h1 className="text">BEAMY</h1>
				<p className="gray">flashcard learning app</p>
		</div>
	);
}

export default HomePage;
